var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipPath: "url(#16_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.394 4.434a1.115 1.115 0 0 1 1.88 0l.415.651a5.1 5.1 0 0 0 1.561 1.56l.651.415.122.088a1.116 1.116 0 0 1 0 1.705l-.122.087-.651.415c-.628.4-1.16.933-1.56 1.561l-.416.651a1.115 1.115 0 0 1-1.792.121l-.088-.12-.415-.652a5.1 5.1 0 0 0-1.56-1.56l-.651-.416a1.115 1.115 0 0 1 0-1.88l.65-.414A5.1 5.1 0 0 0 6.98 5.085zm.85 1.457a6.6 6.6 0 0 1-2.02 2.02L6.084 8l.142.09a6.6 6.6 0 0 1 2.02 2.02l.089.141.09-.14a6.6 6.6 0 0 1 2.02-2.021l.141-.09-.14-.09a6.6 6.6 0 0 1-2.021-2.02l-.09-.141z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.334.583a7.417 7.417 0 1 1-.002 14.834A7.417 7.417 0 0 1 8.334.583m0 1.5a5.917 5.917 0 1 0 0 11.832 5.917 5.917 0 0 0 0-11.832"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "16_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.334 0h16v16h-16z"
  })))));
};
export default Svg16;